const typography = {
  fontFamily: 'Avenir-Medium'
};

export default typography;
